import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledTags } from "./tags.scss";
const Tags = ({ tags, translate })=>{
    var _tags_labels;
    return /*#__PURE__*/ _jsxs(StyledTags, {
        color: tags === null || tags === void 0 ? void 0 : tags.color,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "tags-title-wrapper",
                children: translate("header.tabs.products.tags.bestFor")
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "tags-wrapper",
                children: tags === null || tags === void 0 ? void 0 : (_tags_labels = tags.labels) === null || _tags_labels === void 0 ? void 0 : _tags_labels.map((tag)=>/*#__PURE__*/ _jsx("div", {
                        className: "tag",
                        children: translate(tag)
                    }, tag))
            })
        ]
    });
};
export default Tags;
